import { Injectable, inject } from '@angular/core';
import { BaseParamsService } from '../base-params.service';
import { SetCookieTrackingConsent } from '../store/core-context/core-context-actions';
import { Store } from '@ngrx/store';
import * as fromRoot from '../store/reducers';
import storage from 'local-storage-fallback';

export interface CookieConsentLocalStorage {
  status: boolean;
  date: string;
}

export const COOKIES_CONSENT_KEY = 'cookie_tracking';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  private baseParamsService = inject(BaseParamsService);
  private store = inject<Store<fromRoot.State>>(Store);


  public toggle(enable: boolean, updateMember = true): void {
    enable ? this.accept(updateMember) : this.reject(updateMember);
  }

  public accept(updateMember = true): void {
    this.saveToLocalStorage(true);
    this.store.dispatch(new SetCookieTrackingConsent(true, updateMember));
  }

  public reject(updateMember = true): void {
    this.saveToLocalStorage(false);
    this.store.dispatch(new SetCookieTrackingConsent(false, updateMember));
  }

  public isGiven(): boolean {
    return this.getFromLocalStorage() !== null;
  }

  public isApproved(): boolean {
    return this.isGiven() && !!this.getFromLocalStorage()?.status;
  }

  public getLastUpdateDate(): Date | null {
    const textDate = this.getFromLocalStorage()?.date;
    if (!textDate) { return null; }
    return new Date(textDate);
  }

  private saveToLocalStorage(status: boolean): void {
    storage.setItem(
      this.baseParamsService.cookieConsentKey(),
      JSON.stringify({ date: new Date(), status: status }),
    );
  }

  private getFromLocalStorage(): CookieConsentLocalStorage | null {
    const json = storage.getItem(this.baseParamsService.cookieConsentKey());
    if (!json) {
      return null;
    }
    return <CookieConsentLocalStorage>JSON.parse(json);
  }
}
